import AdminEntity from "../../components/admin/AdminEntity";

export default function AdminTestimonialsPage() {
  return (
    <AdminEntity config={{
      eyebrow: "Testimonials",
      title: "Curated guest testimonials",
      testidPrefix: "admin-testimonials",
      singular: "testimonial",
      addLabel: "New testimonial",
      listEndpoint: "/admin/testimonials",
      keyField: "id",
      columns: [
        { key: "name", label: "Guest", render: (t) => <span className="font-bold" style={{ fontFamily: "'Nunito', sans-serif" }}>{t.name}</span> },
        { key: "location", label: "Location" },
        { key: "rating", label: "Rating" },
        { key: "trip_type", label: "Trip" },
        { key: "hidden", label: "Visible", render: (t) => t.hidden ? "Hidden" : "Visible" },
      ],
      createEndpoint: "/admin/testimonials",
      updateEndpoint: (t) => `/admin/testimonials/${t.id}`,
      deleteEndpoint: (t) => `/admin/testimonials/${t.id}`,
      fields: [
        { name: "name", label: "Guest name", required: true },
        { name: "location", label: "Location" },
        { name: "rating", label: "Rating (1–5)", type: "number", defaultValue: 5 },
        { name: "quote", label: "Quote", type: "textarea", rows: 4, required: true },
        { name: "trip_type", label: "Trip type", help: "e.g. Anniversary, Katy Trail cyclists" },
        { name: "order", label: "Sort order", type: "number", defaultValue: 0 },
        { name: "hidden", label: "Hidden", type: "boolean", checkboxLabel: "Hide from public site" },
      ],
    }} />
  );
}
